import "@fontsource/atkinson-hyperlegible-next/400.css";
import "@fontsource/atkinson-hyperlegible-next/700.css";
import "@fontsource/im-fell-english/400.css";
import "@hexling/ui/styles.css";
import "./app.css";
import { themeCss } from "@hexling/ui";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppDataProvider } from "./data/AppData";
import { SyncEngine } from "./data/sync";
import { UserRepo } from "./data/user";
import { createApi } from "./lib/api";
import { createHexlingAuthClient } from "./lib/auth";
import { apiBaseUrl, openStore, tokenStore } from "./lib/platform";
import { createAppRouter } from "./router";

const style = document.createElement("style");
style.textContent = themeCss();
document.head.append(style);

const store = await openStore();
const api = createApi({ baseUrl: apiBaseUrl(), getToken: () => tokenStore.get() });
const user = new UserRepo(store);
const services = {
  store,
  api,
  user,
  auth: createHexlingAuthClient(),
  sync: new SyncEngine(store, user, api),
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppDataProvider services={services}>
      <RouterProvider router={createAppRouter()} />
    </AppDataProvider>
  </StrictMode>,
);
